module.exports = __webpack_public_path__ + "img/certificating.7b470af6.svg";